<template>
    <div class="slide-page" ref="fullscreenContainer">
        <div class="mb-1 d-flex align-items-center">
            <img
                :src="require('@/assets/img/danantara-logo-black-v3.png')"
                height="40"
                class="ml-2 mt-2"
            />

            <!-- Gambar overlay -->
            <img
                :src="require('@/assets/img/pertare-post-mortem-logo.png')"
                alt="Logo"
                height="80"
                class="overlay-image"
            />

            <div
                class="d-flex align-items-center ml-2 px-2"
                style="
                    height: 60px;
                    background: #d9d9d9;
                    width: 100%;
                    justify-content: space-between;
                    border-top: 15px solid #4472c4;
                "
            >
                <div
                    class="col-auto"
                    style="font-size: 20px; font-weight: bold; color: #002060"
                >
                    {{ maintitle }}
                </div>
                <div class="d-flex align-items-center">
                    <el-button
                        type="primary"
                        size="small"
                        icon="el-icon-s-fold"
                        @click="selectSlide()"
                        circle
                    ></el-button>
                    <el-button
                        type="primary"
                        size="small"
                        icon="el-icon-arrow-left"
                        @click="PrevPage()"
                        circle
                    ></el-button>
                    <div class="mx-2">{{ selectedPage }}/{{ maxPage }}</div>
                    <el-button
                        type="primary"
                        size="small"
                        icon="el-icon-arrow-right"
                        @click="NextPage()"
                        circle
                    ></el-button>
                    <el-button
                        type="primary"
                        size="small"
                        icon="el-icon-refresh-right"
                        @click="refreshPage()"
                        circle
                    ></el-button>
                    <el-button @click="toggleFullscreen" size="small" circle>
                        <i
                            :class="
                                isFullscreen
                                    ? 'fas fa-compress'
                                    : 'fas fa-expand'
                            "
                        ></i>
                    </el-button>
                </div>
            </div>
        </div>
        <div style="padding: 8px">
            <div
                v-for="(item, index) in slidepagedatalist"
                :key="item.clientPageNumber + '_' + index"
            >
                <iframe
                    :ref="`iframe-${item.clientPageNumber}`"
                    :src="item.blobUrl"
                    width="100%"
                    :style="'height: calc(100vh - ' + adjustHeight + 'px);'"
                    frameborder="0"
                    v-show="selectedPage === item.clientPageNumber"
                ></iframe>
                <!--:src="item.blobUrl" :srcdoc="item.htmlDoc" sandbox="allow-scripts allow-same-origin"-->
            </div>
        </div>

        <el-dialog
            title="Select Post Mortem"
            width="80%"
            :visible.sync="dialogVisible"
            :before-close="handleClose"
            :custom-class="'dialog-post-mortem'"
        >
            <div style="min-height: 300px; max-height: 400px; overflow-y: auto">
                <table style="width: 100%" class="tb-post-mortem-slide">
                    <tr>
                        <th>Title</th>
                        <th>Station Id</th>
                        <th>Station Name</th>
                    </tr>
                    <tr
                        v-for="item in slidedatalist"
                        :key="item.Id"
                        :class="{ 'selected-row': selectedRowTemp === item }"
                        @click="selectRow(item)"
                    >
                        <td>{{ item.Title }}</td>
                        <td>{{ item.StationId }}</td>
                        <td>{{ item.StationName }}</td>
                    </tr>
                </table>
                <Loader v-if="loading.slide" />
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">Cancel</el-button>
                <el-button type="primary" @click="selectPostMortem"
                    >Select</el-button
                >
            </span>
        </el-dialog>

        <Loader v-if="loading.slidepage" />
    </div>
</template>

<script>
import Customer from "@/components/page/Customer.js";
import {
    Rainbow,
    FuelColor,
    Config,
    Penanggalan,
    AxiosWithJar,
} from "@/utility.js";
import Loader from "@/components/loader/Loader2.vue";

export default {
    extends: Customer,
    components: {
        Loader,
        //Footer,
        //ListItem,
        //ListItemPiutangByAging,
    },
    mounted() {
        document.addEventListener(
            "fullscreenchange",
            this.fullscreenChangeHandler
        );
        document.addEventListener(
            "webkitfullscreenchange",
            this.fullscreenChangeHandler
        );
        document.addEventListener(
            "mozfullscreenchange",
            this.fullscreenChangeHandler
        );
        document.addEventListener(
            "MSFullscreenChange",
            this.fullscreenChangeHandler
        );
    },
    data() {
        return {
            maintitle: "NO PAGE SELECTED", //2022 – SPBU Modular Universitas Andalas 15.251.010
            slidepagedatalist: [],
            slidedatalist: [],
            selectedRow: null,
            selectedRowTemp: null,
            selectedPage: 0,
            adjustHeight: 160,
            maxPage: 0,
            loading: {
                slide: false,
                slidepage: false,
            },
            isFullscreen: false,
            dialogVisible: false,
        };
    },
    beforeDestroy() {
        document.removeEventListener(
            "fullscreenchange",
            this.fullscreenChangeHandler
        );
        document.removeEventListener(
            "webkitfullscreenchange",
            this.fullscreenChangeHandler
        );
        document.removeEventListener(
            "mozfullscreenchange",
            this.fullscreenChangeHandler
        );
        document.removeEventListener(
            "MSFullscreenChange",
            this.fullscreenChangeHandler
        );
        this.slidepagedatalist.forEach((page) =>
            URL.revokeObjectURL(page.blobUrl)
        );
    },
    watch: {},
    methods: {
        getSlide() {
            this.urlRequestParams = Config().apiURL;
            this.urlRequestParams += "/v1/postmortem/slide?";
            //
            //this.urlRequestParams+='year='+this.year
            //this.urlRequestParams+='&month='+this.month

            this.loading.slide = true;
            AxiosWithJar()
                .get(this.urlRequestParams)
                .then((response) => {
                    this.slidedatalist = response.data.data;
                    //console.log('data: ' + JSON.stringify(this.reportData))
                })
                .catch((error) => {
                    console.log(error);
                    //this.errored = true
                    //error.response.data
                })
                .finally(() => {
                    this.loading.slide = false;
                });
        },

        getSlidePage() {
            this.urlRequestParams = Config().apiURL;
            this.urlRequestParams += "/v1/postmortem/slidepage?";

            //this.urlRequestParams+='year='+this.year
            //this.urlRequestParams+='&month='+this.month
            this.urlRequestParams +=
                "&postmortemslideid=" + this.selectedRow.Id;

            this.loading.slidepage = true;
            AxiosWithJar()
                .get(this.urlRequestParams)
                .then((response) => {
                    this.slidepagedatalist = response.data.data;
                    this.maxPage = response.data?.data?.length;

                    if (this.maxPage > 0) {
                        this.selectedPage = 1;
                    } else {
                        this.selectedPage = 0;
                    }

                    let clientPageNumber = 0;
                    const pagesWithBlob = this.slidepagedatalist.map((page) => {
                        clientPageNumber += 1;
                        const cleanHtml = page.HtmlContent.replace(/\\n/g, "")
                            .replace(/\n/g, "")
                            .replace(/\r/g, "")
                            .replace(/\t/g, "")
                            .trim();

                        const wrappedHtml = `
                            <html>
                            <head>
                                <meta charset="UTF-8" />
                                <style>
                                body {
                                    font-family: Arial, sans-serif;
                                    margin: 0;
                                    padding: 0px;
                                    overflow-x:hidden;
                                    overflow-y:auto;
                                }
                                table {
                                    font-family: inherit;
                                }
                                </style>
                            </head>
                            <body>
                                ${page.HtmlContent}
                            </body>
                            </html>
                        `.trim();

                        //With Highchart
                        let contentHtml = page.HtmlContent.replace(/●/g, '&#9679;');
                        const htmlWrappedChart = `
                        <html>
                            <head>
                                <meta charset="UTF-8" />
                                <style>
                                body {
                                    font-family: "Segoe UI Symbol", "Arial Unicode MS", Arial, sans-serif;
                                    margin: 0;
                                    padding: 0px;
                                    overflow-x:hidden;
                                    overflow-y:auto;
                                }
                                table {
                                    font-family: inherit;
                                     border: 1px solid #CCCCCC;
                                }
                                td {
                                    padding: 4px 8px;
                                     border: 1px solid #CCCCCC;
                                }
                                </style>
                                <script src="https://code.highcharts.com/highcharts.js"></scr` + `ipt>
                                <script src="https://code.highcharts.com/stock/highstock.js"></scr` + `ipt>
                                <script src="https://code.highcharts.com/highcharts-more.js"></scr` + `ipt>
                                <script src="https://code.highcharts.com/highcharts-3d.js"></scr` + `ipt>
                                <script src="https://code.highcharts.com/modules/data.js"></scr` + `ipt>
                                <script src="https://code.highcharts.com/modules/exporting.js"></scr` + `ipt>
                                <script src="https://code.highcharts.com/modules/funnel.js"></scr` + `ipt>
                                <script src="https://code.highcharts.com/6.0.2/modules/annotations.js"></scr` + `ipt>
                                <script src="https://code.highcharts.com/modules/accessibility.js"></scr` + `ipt>
                                <script src="https://code.highcharts.com/modules/solid-gauge.js"></scr` + `ipt>
                            </head>
                            <body>
                                ${contentHtml}
                                <script>
                                    document.addEventListener("DOMContentLoaded", function() {
                                        const containers = document.querySelectorAll(".chart-container");
                                        containers.forEach(container => {
                                            try {
                                                const config = JSON.parse(container.getAttribute("data-chart"));

                                                if (config.series) {
                                                    config.series.forEach(s => {
                                                        delete s._colorIndex;
                                                        delete s._symbolIndex;
                                                    });
                                                }

                                                container.innerHTML = "";
                                                Highcharts.chart(container, config);
                                            } catch (err) {
                                                console.error("Gagal render chart:", err);
                                            }
                                        });
                                    });
                                </scr` + `ipt>
                            </body>
                            </html>
                        `.trim();
                        //End With Highchart

                         const blob = new Blob([htmlWrappedChart], {
                            type: "text/html;charset=utf-8",
                        });
                        const blobUrl = URL.createObjectURL(blob);

                        //const blobUrl = "data:text/html;charset=utf-8," +  encodeURIComponent(wrappedHtml);

                        return {
                            ...page,
                            blobUrl,
                            clientPageNumber,
                        };
                    });

                    this.slidepagedatalist = pagesWithBlob;
                    //console.log('data: ' + JSON.stringify(this.reportData))
                })
                .catch((error) => {
                    console.log(error);
                    //this.errored = true
                    //error.response.data
                })
                .finally(() => {
                    this.loading.slidepage = false;
                });
        },

        selectSlide() {
            this.dialogVisible = true;
            this.getSlide();
        },

        PrevPage() {
            if (this.selectedPage > 1) this.selectedPage -= 1;
        },

        NextPage() {
            if (this.selectedPage < this.maxPage) this.selectedPage += 1;
        },

        refreshPage() {
            this.getSlidePage();
        },

        toggleFullscreen() {
            const el = this.$refs.fullscreenContainer;

            if (!this.isFullscreen) {
                this.adjustHeight = 100;
                if (el.requestFullscreen) {
                    el.requestFullscreen();
                } else if (el.mozRequestFullScreen) {
                    el.mozRequestFullScreen();
                } else if (el.webkitRequestFullscreen) {
                    el.webkitRequestFullscreen();
                } else if (el.msRequestFullscreen) {
                    el.msRequestFullscreen();
                }
            } else {
                this.adjustHeight = 160;
                if (document.exitFullscreen) {
                    document.exitFullscreen();
                } else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen();
                } else if (document.webkitExitFullscreen) {
                    document.webkitExitFullscreen();
                } else if (document.msExitFullscreen) {
                    document.msExitFullscreen();
                }
            }
        },
        fullscreenChangeHandler() {
            this.isFullscreen = !!(
                document.fullscreenElement ||
                document.webkitFullscreenElement ||
                document.mozFullScreenElement ||
                document.msFullscreenElement
            );
        },

        handleClose(done) {
            done();
        },
        selectRow(item) {
            this.selectedRowTemp = item;
        },
        selectPostMortem() {
            this.dialogVisible = false;
            this.selectedRow = this.selectedRowTemp;
            this.maintitle = this.selectedRow.Title;
            //console.log("Selected Row: " + JSON.stringify(this.selectedRow));
            this.getSlidePage();
        },
    },
};
</script>

<style>
.slide-page {
    background: #ffffff;
    padding: 0px;
    min-height: 700px;
}

iframe {
    width: 100%;
    border: none;
}

.overlay-image {
    position: absolute;
    right: 250px; /* jarak dari kanan, sesuaikan dengan lebar div button */
    top: 30px;
    transform: translateY(-50%);
    pointer-events: none; /* supaya gambar tidak mengganggu klik */
    z-index: 10;
}

.dialog-post-mortem {
    padding: 0px 0px;
}

.dialog-post-mortem .el-dialog__body {
    padding: 10px 20px;
}

.tb-post-mortem-slide td {
    padding: 8px 12px;
    border-bottom: 1px solid #ddd;
}

.tb-post-mortem-slide tr:nth-child(even) {
    background-color: #f9f9f9;
}

.tb-post-mortem-slide tr:hover {
    background-color: #f1f1f1;
}

.tb-post-mortem-slide tr {
    cursor: pointer;
}

.selected-row {
    background-color: #409EFF !important;
    color: #FFFFFF;
    font-weight: bold;
}

/*
.content-preview table {
    border-collapse: collapse !important;
    width: 100% !important;
}

.content-preview thead, .content-preview tbody, .content-preview tfoot,
.content-preview tr, .content-preview td, .content-preview th {
    border-color: inherit !important;
    border-style: solid !important;
    border-width: 1px !important;
    padding: 5px !important;
}

.content-preview table td, .content-preview table th {
    padding: 8px;
    text-align: left;
    vertical-align: top;
    border: 1px solid #ccc;
}

.content-preview h1, .content-preview h2, .content-preview h3, .content-preview p {
    margin-bottom: 15px;
    font-family: Arial, sans-serif;
}
*/
</style>
